module.exports = __webpack_public_path__ + "images/46b0c860639f78f471ae3e4869e3c880.svg";